import { InitUserInput, User } from 'types/graphql'

import { useMutation } from '@redwoodjs/web'

type UpdateUserResponse = {
  initUser: Pick<
    User,
    'id' | 'email' | 'creatorStatus' | 'usePassword' | 'isFirstLogin'
  >
}

type UpdateUserRequest = {
  input: InitUserInput
}

const INIT_USER_MUTATION = gql`
  mutation InitUserMutation($input: InitUserInput!) {
    initUser(input: $input) {
      id
      email
      creatorStatus
      usePassword
      isFirstLogin
    }
  }
`

const useInitUser = (
  options?: GraphQLMutationHookOptions<UpdateUserResponse, UpdateUserRequest>
): MutationOperationResult<UpdateUserResponse, UpdateUserRequest> => {
  return useMutation<UpdateUserResponse, UpdateUserRequest>(
    INIT_USER_MUTATION,
    options
  )
}

export default useInitUser
